import React from 'react'
import { PrismicRichText, PrismicLink } from '@prismicio/react'
import PropTypes from 'prop-types'
import { GatsbyImage } from 'gatsby-plugin-image'

const IconCards = ({ slice }) => {
  return (
    <section className='component-IconCards'>
      <div className='icon-card text-white'>
        {slice.primary.title && (
          <div className={`prose prose-invert mx-auto mb-6 text-center`}>
            <PrismicRichText field={slice.primary.title.richText} />
          </div>
        )}
        <ul className='flex flex-col gap-3 mb-12'>
          {slice.items.map((icon, index) => {
            return (
              <li className='flex text-lg items-center gap-3' key={`icon-${index}`}>
                <div className='rounded-md icon w-16'>
                  <GatsbyImage className='m-3' image={icon.icon.gatsbyImageData} alt={icon.icon.alt || ''} />
                </div>
                {icon.icon_copy}
              </li>
            )
          })}
        </ul>
        {slice.primary.button_link && (
          <div className='mt-auto z-10'>
            <PrismicLink className='button button-info text-lg' field={slice.primary.button_link}>
              {slice.primary.button_text ? slice.primary.button_text : 'Read more'}
              <span className='absolute inset-0 cursor-pointer' aria-hidden='true'></span>
            </PrismicLink>
          </div>
        )}
      </div>
    </section>
  )
}

IconCards.propTypes = {
  slice: PropTypes.object.isRequired
}

export default IconCards
